<div class="naviBar" fxLayout.xs="row">
  <div class="naviItems">
    <button mat-icon-button [disabled]="!this.allowBackwardNavigation" (click)="this.navigateBackward()">
      <mat-icon class="naviButton" [svgIcon]="res.svgName('Navigation-ArrowLeft-Image')"></mat-icon>
    </button>
    <button mat-icon-button [disabled]="!this.allowForwardNavigation" (click)="this.navigateForward()">
      <mat-icon class="naviButton" [svgIcon]="res.svgName('Navigation-ArrowRight-Image')"></mat-icon>
    </button>
  </div>
  <div class="left-items">
    <button
      mat-icon-button
      [disabled]="!this.allowAdding"
      [ngStyle]="{ display: !this.frame.mapInfo.isReadOnly ? 'inline' : 'none' }"
      (click)="this.add()"
    >
      <mat-icon [svgIcon]="res.svgName('Add-Image')"></mat-icon>
    </button>
    <button
      mat-icon-button
      [disabled]="!this.allowEditing"
      [ngStyle]="{ display: !this.frame.mapInfo.isReadOnly ? 'inline' : 'none' }"
      (click)="this.edit()"
    >
      <mat-icon [svgIcon]="res.svgName('Edit-Image')"></mat-icon>
    </button>
    <button
      mat-icon-button
      [ngStyle]="{ display: !this.frame.mapInfo.isReadOnly ? 'inline' : 'none' }"
      [disabled]="!this.needForPersistence"
      (click)="this.save()"
    >
      <mat-icon [svgIcon]="res.svgName('Save-Image')"></mat-icon>
    </button>
    <button
      mat-icon-button
      [ngStyle]="{ display: !this.frame.mapInfo.isReadOnly ? 'inline' : 'none' }"
      [disabled]="!this.allowCanceling"
      (click)="this.cancel()"
    >
      <mat-icon [svgIcon]="res.svgName('Cancel-Image')"></mat-icon>
    </button>
    <button
      mat-icon-button
      [disabled]="!this.allowDeleting"
      [ngStyle]="{ display: !this.frame.mapInfo.isReadOnly ? 'inline' : 'none' }"
      (click)="this.delete()"
    >
      <mat-icon [svgIcon]="res.svgName('Delete-Image')"></mat-icon>
    </button>
  </div>
</div>
